import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel and track PageView on load
    initMetaPixel();
    trackPageView();
  }, []);
  return <LandingPage data-id="element-0" />;
}